import {
  Switch,
  Redirect,
  generatePath,
  Route,
} from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { RegisterEmail } from './features/question/RegisterEmail';
import { InputAnswer } from './features/question/InputAnswer';
import { InputAnswerCompleted } from './features/question/InputAnswerCompleted';

import { appPath, paramName } from './router/AppRoute';
import { CouponIntroRoute } from './router/CouponIntroRoute';
import { RegisterEmailRoute } from './router/GetCouponRoute';
import { InputRoute } from './router/InputRoute';
import { SentRoute } from './router/SentRoute';
import { InputBranchRoute } from './router/InputBranchRoute';

import { Box, Button, CircularProgress, Grid, Typography, Container } from '@material-ui/core';
import { useState } from 'react';
import { RegisterEmailCompleted } from './features/question/RegisterEmailCompleted';
import { useAppSelector } from './app/hooks';
import { CouponIntro } from './features/question/CouponIntro';
import { MyAppBar } from "./features/appbar/MyAppBar";
import { MyFooter } from "./features/footer/MyFooter";
import { InputAnswerPreview } from "./features/preview/InputAnswerPreview";
import { CouponPreview } from "./features/preview/CouponPreview";
import { InputBranch } from './features/question/InputBranch';

export function AppShopqrMain(props: {
}) {
  /** Preview mode */
  const { t } = useTranslation();
  const isPreviewMode = useAppSelector(state => state.preview.isReviewMode);
  const isCoupon = useAppSelector(state => state.preview.coupon.isCoupon);

  const session = useAppSelector(state => {
    return state.inputAnswer.session;
  });

  const answerStatus = useAppSelector(state => {
    return state.inputAnswer.answer.status;
  })

  const registerEmailStatus = useAppSelector((state) => {
    return state.inputAnswer.couponState?.registerEmailStatus;
  })

  const [reloading, setReloading] = useState(false);

  if (reloading) {
    return (
      <Box display="flex" position="fixed" left="0" top="0" right="0" bottom="0" alignItems="center" mx={5}>
        <Grid container spacing={0} direction="column" alignItems="center" justify="center">
          <div><CircularProgress /></div>
          <Typography variant="h4">now loading …</Typography>
        </Grid>
      </Box>
    );
  }

  const handleReloadClicked = () => {

    setReloading(true);
    window.location.reload();
  };

  const toUrlInput0 = generatePath(
    appPath.shopqr.inputAnswer,
    {
      [paramName.surveyQestionPageIndexStr]: 0,
    }
  )

  const toUrlCouponIntro = generatePath(
    appPath.shopqr.couponIntro,
  )

  const toUrlInputPreview = generatePath(appPath.shopqr.inputAnswerPreview, {
    [paramName.surveyQestionPageIndexStr]: 0,
  });
  const toUrlCouponPreview = generatePath(appPath.shopqr.couponPreview);

  let defaultUrl: string;

  if (session.cxHttpRes?.data?.cxShopToken?.cxCoupon) {
    defaultUrl = toUrlCouponIntro;
  } else {
    defaultUrl = toUrlInput0;
  }

  /** Preview mode */
  if (isPreviewMode) {
    defaultUrl = isCoupon ? toUrlCouponPreview : toUrlInputPreview;
  }

  // 回答送信中でないか確認する
  if (answerStatus === 'pending') {
    return (
      <Box display="flex" position="fixed" left="0" top="0" right="0" bottom="0" alignItems="center" mx={5}>
        <Grid container spacing={0} direction="column" alignItems="center" justify="center">
          <div><CircularProgress /></div>
          <Typography variant="h4">{t('appBar.sending')}</Typography>
        </Grid>
      </Box>
    );
  }

  // 回答送信に失敗していないかチェックする
  if (answerStatus === 'rejected') {
    return (
      <Container
        maxWidth={false}
        disableGutters={true}
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden"
        }}
      >
        <MyAppBar />
        <Box mt={2} flexGrow="1" position="relative">
          <Box mx={3} mt={1}>
            <Typography variant="h6">
              <Box fontWeight="fontWeightBold">{t('appBar.registration_process_failed')}</Box>
            </Typography>
          </Box>
          <Box mx={3} mt={3}>
            <Typography component="span">
              <Box>{t('appBar.it_is_possible_that_multiple_windows_or_tabs_are_currently_in_operation')}</Box>
              <Box>{t('appBar.please_check_your_browser_and_then_try_again')}</Box>
            </Typography>
          </Box>
          <Button
            style={{
              position: "absolute",
              top: "50%",
              left: "calc(50% - 60px)"
            }}
            variant="contained"
            onClick={handleReloadClicked}
          >
            {t('common.btn.refresh')}
          </Button>
        </Box>
        <MyFooter />
      </Container>
    );
  }

  // メールアドレス登録済みの場合
  if (registerEmailStatus && registerEmailStatus === 'fulfilled') {
    return <RegisterEmailCompleted />
  }

  // 回答済みの場合、完了ページを表示する -> クーポン表示ページと遷移を行き来したいので、Router配下に移動
  // if (answerStatus === 'fulfilled' || session.httpRes?.data?.shopqrSession.survey.answered) {
  //   return <InputAnswerCompleted />
  // }

  return (
    <Switch>
      <Route
        exact
        path={appPath.shopqr.couponPreview}
        component={CouponPreview}
      />
      <Route
        exact
        path={appPath.shopqr.inputAnswerPreview}
        component={InputAnswerPreview}
      />
      <CouponIntroRoute
        path={appPath.shopqr.couponIntro}
        component={CouponIntro}
      />
      <InputBranchRoute
        path={appPath.shopqr.inputBranch}
        component={InputBranch}
      />
      <InputRoute
        exact
        path={appPath.shopqr.inputAnswer}
        component={InputAnswer}
      />
      <SentRoute
        exact
        path={appPath.shopqr.sentAnswer}
        component={InputAnswerCompleted}
      />
      <RegisterEmailRoute
        exact
        path={appPath.shopqr.registerEmail}
        component={RegisterEmail}
      />
      <Redirect to={defaultUrl} />
    </Switch>
  );
}
